import { isNative } from '@dhl/webview'
import { getPaymentProvider } from './getPaymentProvider'
import { PaymentProviderAction, PaymentProviderResult } from './types'

const appendParamsToUrl = (url: string, params: { [key: string]: string } | undefined) => {
  const urlParams = new URLSearchParams()
  // eslint-disable-next-line no-restricted-syntax
  for (const key in params) {
    // eslint-disable-next-line no-prototype-builtins
    if (params.hasOwnProperty(key)) {
      urlParams.append(key, params[key])
    }
  }
  const requestParamString = urlParams.size === 0 ? '' : `?${urlParams.toString()}`
  return `${url}${requestParamString}`
}

const redirectAction = (url: string, params?: { [key: string]: string } | undefined) => {
  const redirectUrl = appendParamsToUrl(url, params)
  window.location.href = redirectUrl
}

export const formPostActionNative = (url: string, params?: { [key: string]: string }) => {
  const paymentLink = document.createElement('a')
  paymentLink.setAttribute('href', appendParamsToUrl(url, params))
  paymentLink.setAttribute('style', 'display: none')
  document.body.appendChild(paymentLink)
  paymentLink.click()
}

const formPostActionDesktop = (url: string, params?: { [key: string]: string } | undefined) => {
  const form = document.createElement('form')
  form.setAttribute('method', 'post')
  form.setAttribute('action', url)

  // eslint-disable-next-line no-restricted-syntax
  for (const key in params) {
    // eslint-disable-next-line no-prototype-builtins
    if (params.hasOwnProperty(key)) {
      const hiddenField = document.createElement('input')
      hiddenField.setAttribute('type', 'hidden')
      hiddenField.setAttribute('name', key)
      hiddenField.setAttribute('value', params[key])

      form.appendChild(hiddenField)
    }
  }

  document.body.appendChild(form)
  form.submit()
}

export const handlePaymentAction = (data: PaymentProviderAction) => {
  switch (data.type) {
    case 'FormPostAction':
      if (isNative()) {
        formPostActionNative(data.url, data.fields)
      } else {
        formPostActionDesktop(data.url, data.fields)
      }
      break
    case 'RedirectAction':
      redirectAction(data.url)
      break
    default:
      break
  }
}

export const doPayment = async (
  orderId: number,
  usePaymentService: boolean,
  brand: string | null,
  issuerId: string | null
): Promise<PaymentProviderResult> => getPaymentProvider(orderId, usePaymentService, brand, issuerId)
